"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputField_1 = __importDefault(require("../Fields/InputField"));
function BillingFirstNameField(props, ref) {
    return (react_1.default.createElement(InputField_1.default, __assign({ ref: ref, name: 'billingFirstName', label: 'First Name', placeholder: 'First Name', autoComplete: 'cc-given-name' }, props)));
}
exports.default = react_1.default.forwardRef(BillingFirstNameField);
